module.exports = "/* hr {\r\n    border-top: 2px groove   #27408B !important;\r\n    color: #27408B\t !important; \r\n  \r\n    \r\n} */"